export const parseURL = (url: string): URL => {
  try {
    // URL class throws if attempting to instantiate with invalid URL
    return new URL(url);
  } catch {
    return;
  }
};
